export default __webpack_public_path__ + "static/media/food.5542d53f.png";